import { PARTICIPANT_LEFT } from '../base/participants/actionTypes';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { CLEAR_AUDIO_TRANSLATION, CLEAR_RECEIVING_TRANSLATED_SOURCES, SET_AUDIO_TRANSLATION_LANGUAGE, SET_PARTICIPANT_AUDIO_TRANSLATION_LANGUAGE, SET_TRANSLATION_LISTENERS, UPDATE_TRANSLATED_SOURCE_SENDING } from './actionTypes';
const DEFAULT_STATE = {
    language: null,
    participantLanguages: {},
    receivingSources: [],
    translationListeners: []
};
ReducerRegistry.register('features/audio-translation', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case CLEAR_AUDIO_TRANSLATION:
            // Only the local selection. receivingSources and translationListeners are reported by the backend
            // and describe the whole conference, so they stay until it says otherwise.
            return {
                ...state,
                language: null,
                participantLanguages: {}
            };
        case CLEAR_RECEIVING_TRANSLATED_SOURCES:
            return {
                ...state,
                receivingSources: []
            };
        case SET_AUDIO_TRANSLATION_LANGUAGE:
            return {
                ...state,
                language: action.language
            };
        case SET_PARTICIPANT_AUDIO_TRANSLATION_LANGUAGE:
            return {
                ...state,
                participantLanguages: {
                    ...state.participantLanguages,
                    [action.participantId]: action.language
                }
            };
        case PARTICIPANT_LEFT: {
            // Choice and in-flight audio must not outlive the speaker: no stop event arrives for a departed
            // endpoint, so the meeting label would never clear.
            const { id } = action.participant;
            const { [id]: _left, ...participantLanguages } = state.participantLanguages;
            const receivingSources = state.receivingSources.filter(source => !source.startsWith(`${id}-`));
            if (_left === undefined && receivingSources.length === state.receivingSources.length) {
                return state;
            }
            return { ...state, participantLanguages, receivingSources };
        }
        case SET_TRANSLATION_LISTENERS:
            return {
                ...state,
                translationListeners: action.ids
            };
        case UPDATE_TRANSLATED_SOURCE_SENDING: {
            const has = state.receivingSources.includes(action.sourceName);
            if (action.sending === has) {
                return state;
            }
            return {
                ...state,
                receivingSources: action.sending
                    ? [...state.receivingSources, action.sourceName]
                    : state.receivingSources.filter((source) => source !== action.sourceName)
            };
        }
        default:
            return state;
    }
});
